import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Axios from 'axios';
import './ccss/sb-admin-2.min.css';
import { useCookies } from 'react-cookie';
import config from './Componentes/config';
import useLogout from './Componentes/useLogout';
import PermisosModal from './Modals/PermisosModal';

function Sidebar({ imageUrl, cookies, isComponentsCollapsed, toggleCollapse, setIsComponentsCollapsed, isUtilitiesCollapsed, setIsUtilitiesCollapsed, isContabilidadCollapsed, setIsContabilidadCollapsed, isPrevencion, setisPrevencionCollapsed, isLogistica, setisLogisticaCollapsed, isInventario, setisIventatioCollapsed, isAdministracionCollapsed, setIsAdministracionCollapsed }) {
    const [isSidebarToggled, setIsSidebarToggled] = React.useState(true);
    const [isMenuActive, setIsMenuActive] = React.useState(false);
    const [cookiesState, setCookie] = useCookies(['selectedCard']);
    const [permisosModulos, setPermisosModulos] = useState([]);
    const [expandedMenus, setExpandedMenus] = useState({});
    const [listadoVacaciones, setlistadoVacaciones] = useState([]);
    const [listadoSolicitudesOrdenesCompra, setListadoSolicitudesOrdenesCompra] = useState([]);
    const [showPermisosModal, setShowPermisosModal] = useState(false);
    const [showNotifications, setShowNotifications] = useState(false);
    const [showProfileMenu, setShowProfileMenu] = useState(false);
    const [activePopup, setActivePopup] = useState(null);
    const [popupPosition, setPopupPosition] = useState({ top: 0, left: 101 });
    const userId = (cookies || cookiesState).userId;
    const usuario = (cookies || cookiesState).usuario;
    const selectedCard = (cookies || cookiesState).selectedCard;
    const idEmpresa = (cookies || cookiesState).idEmpresa;
    const logout = useLogout();

    // Función para obtener el color según la empresa
    const getEmpresaColor = (card) => {
        switch (card) {
            case 'FUGA':
                return 'sidebar-orange'; // Fugar - naranja
            case 'TRAN':
                return 'sidebar-gray'; // Extasis - gris
            case 'INVE':
                return 'sidebar-green'; // Grupo de Inversiones DAFA - verde
            case 'NIDI':
                return 'sidebar-cyan'; // Nidiam - celeste
            case 'DAFA':
            default:
                return 'sidebar-blue'; // DAFA - azul (por defecto)
        }
    };

    // Tema de popups según la empresa
    const getPopupTheme = (card) => {
        switch (card) {
            case 'FUGA':
                return 'theme-orange';
            case 'TRAN':
                return 'theme-gray';
            case 'INVE':
                return 'theme-green';
            case 'NIDI':
                return 'theme-cyan';
            case 'DAFA':
            default:
                return 'theme-blue';
        }
    };

    // Expandir/colapsar el sidebar según el hover del mouse (solo escritorio).
    // El sidebar queda colapsado por defecto para ganar espacio constante y se
    // expande como overlay al pasar el mouse, sin reacomodar el contenido.
    const handleSidebarMouseEnter = () => {
        if (window.innerWidth >= 1024) {
            setIsSidebarToggled(false);
        }
    };

    const handleSidebarMouseLeave = () => {
        if (window.innerWidth >= 1024) {
            setIsSidebarToggled(true);
            setActivePopup(null); // Cerrar popups al colapsar
        }
    };

    const toggleMenu = () => {
        setIsMenuActive(!isMenuActive);
    };

    const toggleSubmenu = (menuKey, event) => {
        if (isSidebarToggled) {
            // Cuando el sidebar está colapsado, manejar popups
            if (activePopup === menuKey) {
                setActivePopup(null);
            } else {
                // Calcular posición del popup basado en el elemento clickeado
                const rect = event.currentTarget.getBoundingClientRect();
                const windowHeight = window.innerHeight;
                const popupHeight = 275; // Altura estimada del popup

                // Para elementos en la parte inferior (perfil), posicionar hacia arriba
                let topPosition = rect.top;
                if (menuKey === 'perfil') {
                    // Siempre posicionar hacia arriba para elementos del footer
                    topPosition = rect.top - popupHeight + 20; // 20px de margen desde el elemento

                    // Asegurarse de que no se salga por arriba de la pantalla
                    if (topPosition < 20) {
                        topPosition = 20;
                    }
                }

                setPopupPosition({
                    top: topPosition,
                    left: 101 // 85px sidebar width + 16px margin
                });
                setActivePopup(menuKey);
            }
        } else {
            // Cuando el sidebar está expandido, manejar submenús normales
            // Solo permitir un menú abierto a la vez con transición suave
            setExpandedMenus(prev => {
                const isCurrentlyExpanded = prev[menuKey];
                const hasOtherExpanded = Object.keys(prev).some(key => key !== menuKey && prev[key]);

                if (isCurrentlyExpanded) {
                    // Si el menú actual está abierto, cerrarlo
                    return {};
                } else if (hasOtherExpanded) {
                    // Si hay otro menú abierto, cerrarlo primero y luego abrir el nuevo
                    // Primero cerrar todos
                    setTimeout(() => {
                        setExpandedMenus({ [menuKey]: true });
                    }, 50); // Pequeño delay para suavizar la transición
                    return {};
                } else {
                    // No hay menús abiertos, abrir directamente el seleccionado
                    return { [menuKey]: true };
                }
            });
        }
    };

    const toggleNotifications = () => {
        // Si el sidebar está colapsado, hacer el flow secuencial
        if (isSidebarToggled) {
            // Cerrar cualquier popup activo primero
            setActivePopup(null);

            // Paso 1: Expandir el sidebar (duración: 400ms)
            setIsSidebarToggled(false);

            // Paso 2: Esperar que termine completamente la animación del sidebar
            setTimeout(() => {
                // Paso 3: Abrir el panel de notificaciones
                setShowNotifications(true);
                setShowProfileMenu(false);
            }, 420); // 400ms de transición + 20ms de margen para suavidad
        } else {
            // Comportamiento normal cuando está expandido
            setShowNotifications(!showNotifications);
            setShowProfileMenu(false);
        }
    };

    const toggleProfileMenu = () => {
        setShowProfileMenu(!showProfileMenu);
        setShowNotifications(false);
    };

    useEffect(() => {
        console.log("Cookie userId:", userId, "idEmpresa:", idEmpresa); // Verifica que se obtiene correctamente
        if (userId && idEmpresa) {
            // Obtener permisos de los módulos del usuario para la empresa actual
            Axios.get(`${config.API_URL}/getPermisosModulos`, {
                params: {
                    userId: userId,
                    empresaId: idEmpresa
                }
            })
                .then((response) => {
                    // Guardar tanto nombres de módulos como submódulos permitidos
                    setPermisosModulos(response.data.map(modulo => modulo.Modulo));
                })
                .catch((error) => {
                    console.error("Error al cargar los permisos:", error);
                    setPermisosModulos([]); // Array vacío en caso de error
                });
        } else {
            console.error("No se encontró userId o idEmpresa en las cookies");
            setPermisosModulos([]);
        }
    }, [userId, idEmpresa]);

    // Cargar solicitudes de vacaciones y órdenes de compra
    useEffect(() => {
        if (!idEmpresa) {
            setlistadoVacaciones([]);
            setListadoSolicitudesOrdenesCompra([]);
            return;
        }

        const getSolicitudesVacaciones = () => {
            console.log("Cargando solicitudes de vacaciones");
            Axios.get(`${config.API_URL}/cargaSolicitudesVacaciones`, {
                params: { idEmpresa }
            })
                .then(res => {
                    if (Array.isArray(res.data)) {
                        setlistadoVacaciones(res.data);
                    } else {
                        console.error('La respuesta no es un array:', res.data);
                        setlistadoVacaciones([]);
                    }
                })
                .catch(err => {
                    console.error("Error al obtener los datos:", err);
                    setlistadoVacaciones([]);
                });
        };

        const getSolicitudesOrdenesCompra = () => {
            console.log("Cargando solicitudes de órdenes de compra");
            Axios.get(`${config.API_URL}/cargaSolicitudesAprobacion`, {
                params: { idEmpresa }
            })
                .then(res => {
                    if (Array.isArray(res.data)) {
                        // Filtrar solo las solicitudes de órdenes de compra
                        const solicitudesOrdenes = res.data.filter(solicitud =>
                            solicitud.Tipo_Solicitud === 'Aprobacion_Orden_Compra'
                        );
                        setListadoSolicitudesOrdenesCompra(solicitudesOrdenes);
                    } else {
                        console.error('La respuesta no es un array:', res.data);
                        setListadoSolicitudesOrdenesCompra([]);
                    }
                })
                .catch(err => {
                    console.error("Error al obtener solicitudes de órdenes:", err);
                    setListadoSolicitudesOrdenesCompra([]);
                });
        };

        getSolicitudesVacaciones();
        getSolicitudesOrdenesCompra();

        // Configurar intervalo para actualizar cada 30 segundos
        const interval = setInterval(() => {
            getSolicitudesVacaciones();
            getSolicitudesOrdenesCompra();
        }, 30000);

        return () => clearInterval(interval);
    }, [idEmpresa]);

    // Effect for responsive behavior
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth >= 1024) {
                setIsMenuActive(false);
            } else {
                setIsSidebarToggled(false);
            }
        };

        // Update content wrapper margin based on sidebar state
        const updateContentMargin = () => {
            const contentWrappers = document.querySelectorAll('#content-wrapper');
            contentWrappers.forEach(wrapper => {
                if (window.innerWidth >= 1024) {
                    // Margen fijo al ancho colapsado: el sidebar se expande como
                    // overlay al hacer hover y no reacomoda el contenido.
                    wrapper.style.marginLeft = '101px';
                } else {
                    wrapper.style.marginLeft = '0';
                }
            });
        };

        // Close panels when clicking outside
        const handleClickOutside = (event) => {
            if (!event.target.closest('.nav-item')) {
                setShowNotifications(false);
                setShowProfileMenu(false);
                setActivePopup(null);
            }
        };

        // Close popups when sidebar expands
        if (!isSidebarToggled) {
            setActivePopup(null);
        }

        handleResize();
        updateContentMargin();

        window.addEventListener('resize', () => {
            handleResize();
            updateContentMargin();
        });

        document.addEventListener('click', handleClickOutside);

        return () => {
            window.removeEventListener('resize', handleResize);
            document.removeEventListener('click', handleClickOutside);
        };
    }, [isSidebarToggled, isMenuActive]);

    // Función para verificar permisos tanto de módulos como submódulos
    const hasPermission = (modulo) => permisosModulos.includes(modulo);

    // Función para verificar si el usuario tiene acceso a algún submódulo del módulo principal
    const hasAnySubmodulePermission = (submodulos) => {
        return submodulos.some(submodulo => hasPermission(submodulo));
    };
    console.log("id front: " + userId);

    // Función para renderizar popups fuera del sidebar
    const renderPopups = () => {
        if (!isSidebarToggled || !activePopup) return null;

        const popupStyle = {
            '--popup-left': `${popupPosition.left}px`,
            '--popup-top': `${popupPosition.top}px`
        };

        switch (activePopup) {
            case 'recursosHumanos':
                return (
                    <div className={`module-popup ${getPopupTheme(selectedCard)}`} style={popupStyle}>
                        <div className="popup-header">
                            <span className="material-symbols-rounded">group</span>
                            <h3>Recursos Humanos</h3>
                            <button className="popup-close" onClick={() => setActivePopup(null)}>
                                <span className="material-symbols-rounded">close</span>
                            </button>
                        </div>
                        <div className="popup-body">
                            {hasPermission("Trabajadores") && (
                                <Link className="popup-item" to="/Trabajadores" onClick={() => setActivePopup(null)}>
                                    <span className="popup-icon material-symbols-rounded">badge</span>
                                    <span className="popup-label">Trabajadores</span>
                                </Link>
                            )}
                            {hasPermission("Trabajadores") && (
                                <Link className="popup-item" to="/Contratos" onClick={() => setActivePopup(null)}>
                                    <span className="popup-icon material-symbols-rounded">description</span>
                                    <span className="popup-label">Contratos</span>
                                </Link>
                            )}
                            {hasPermission("Compensados") && (
                                <Link className="popup-item" to="/Compensados" onClick={() => setActivePopup(null)}>
                                    <span className="popup-icon material-symbols-rounded">description</span>
                                    <span className="popup-label">Compensados</span>
                                </Link>
                            )}
                            {hasPermission("Permisos") && (
                                <Link className="popup-item" to="/Permisos" onClick={() => setActivePopup(null)}>
                                    <span className="popup-icon material-symbols-rounded">schedule</span>
                                    <span className="popup-label">Permisos</span>
                                </Link>
                            )}
                            {hasPermission("Vacaciones") && (
                                <Link className="popup-item" to="/Vacaciones" onClick={() => setActivePopup(null)}>
                                    <span className="popup-icon material-symbols-rounded">beach_access</span>
                                    <span className="popup-label">Vacaciones</span>
                                </Link>
                            )}
                            {hasPermission("Colaciones") && (
                                <Link className="popup-item" to="/Colaciones" onClick={() => setActivePopup(null)}>
                                    <span className="popup-icon material-symbols-rounded">restaurant</span>
                                    <span className="popup-label">Colaciones</span>
                                </Link>
                            )}
                            {hasPermission("Liquidaciones") && (
                                <Link className="popup-item" to="/Liquidaciones" onClick={() => setActivePopup(null)}>
                                    <span className="popup-icon material-symbols-rounded">receipt_long</span>
                                    <span className="popup-label">Liquidaciones</span>
                                </Link>
                            )}
                            {hasPermission("Asistencia") && (
                                <Link className="popup-item" to="/Asistencia" onClick={() => setActivePopup(null)}>
                                    <span className="popup-icon material-symbols-rounded">event_available</span>
                                    <span className="popup-label">Asistencia</span>
                                </Link>
                            )}
                            {hasPermission("Finiquitos") && (
                                <Link className="popup-item" to="/Finiquitos" onClick={() => setActivePopup(null)}>
                                    <span className="popup-icon material-symbols-rounded">contract</span>
                                    <span className="popup-label">Finiquitos</span>
                                </Link>
                            )}
                        </div>
                    </div>
                );

            case 'contabilidad':
                return (
                    <div className={`module-popup ${getPopupTheme(selectedCard)}`} style={popupStyle}>
                        <div className="popup-header">
                            <span className="material-symbols-rounded">attach_money</span>
                            <h3>Contabilidad</h3>
                            <button className="popup-close" onClick={() => setActivePopup(null)}>
                                <span className="material-symbols-rounded">close</span>
                            </button>
                        </div>
                        <div className="popup-body">
                            {hasPermission("CreaLiquidaciones") && (
                                <Link className="popup-item" to="/CreacionLiquidaciones" onClick={() => setActivePopup(null)}>
                                    <span className="popup-icon material-symbols-rounded">receipt_long</span>
                                    <span className="popup-label">Liquidaciones</span>
                                </Link>
                            )}
                            {hasPermission("Centro Costos") && (
                                <Link className="popup-item" to="/CentroCostos" onClick={() => setActivePopup(null)}>
                                    <span className="popup-icon material-symbols-rounded">account_balance</span>
                                    <span className="popup-label">Centro Costos</span>
                                </Link>
                            )}
                        </div>
                    </div>
                );

            case 'inventario':
                return (
                    <div className={`module-popup ${getPopupTheme(selectedCard)}`} style={popupStyle}>
                        <div className="popup-header">
                            <span className="material-symbols-rounded">inventory_2</span>
                            <h3>Inventario</h3>
                            <button className="popup-close" onClick={() => setActivePopup(null)}>
                                <span className="material-symbols-rounded">close</span>
                            </button>
                        </div>
                        <div className="popup-body">
                            {hasPermission("Gestion Inventario") && (
                                <Link className="popup-item" to="/Inventario" onClick={() => setActivePopup(null)}>
                                    <span className="popup-icon material-symbols-rounded">warehouse</span>
                                    <span className="popup-label">Gestión de Productos</span>
                                </Link>
                            )}
                            {hasPermission("Asignacion Inventario") && (
                                <Link className="popup-item" to="/AsignacionInventario" onClick={() => setActivePopup(null)}>
                                    <span className="popup-icon material-symbols-rounded">assignment_ind</span>
                                    <span className="popup-label">Asignaciones</span>
                                </Link>
                            )}
                        </div>
                    </div>
                );

            case 'prevencion':
                return (
                    <div className={`module-popup ${getPopupTheme(selectedCard)}`} style={popupStyle}>
                        <div className="popup-header">
                            <span className="material-symbols-rounded">construction</span>
                            <h3>Prevención</h3>
                            <button className="popup-close" onClick={() => setActivePopup(null)}>
                                <span className="material-symbols-rounded">close</span>
                            </button>
                        </div>
                        <div className="popup-body">
                            {hasPermission("Faenas") && (
                                <Link className="popup-item" to="/prevencion/Faenas" onClick={() => setActivePopup(null)}>
                                    <span className="popup-icon material-symbols-rounded">format_list_numbered</span>
                                    <span className="popup-label">Faenas</span>
                                </Link>
                            )}
                            {hasPermission("Registro Prevencion") && (
                                <Link className="popup-item" to="/prevencion/RegistroPrevencion" onClick={() => setActivePopup(null)}>
                                    <span className="popup-icon material-symbols-rounded">print</span>
                                    <span className="popup-label">Registro prevención</span>
                                </Link>
                            )}
                            {hasPermission("Documentos") && (
                                <Link className="popup-item" to="/prevencion/Documentos" onClick={() => setActivePopup(null)}>
                                    <span className="popup-icon material-symbols-rounded">description</span>
                                    <span className="popup-label">Documentos</span>
                                </Link>
                            )}
                            {hasPermission("Formatos") && (
                                <Link className="popup-item" to="/prevencion/Formatos" onClick={() => setActivePopup(null)}>
                                    <span className="popup-icon material-symbols-rounded">article</span>
                                    <span className="popup-label">Formatos</span>
                                </Link>
                            )}
                            {hasPermission("Procedimientos") && (
                                <Link className="popup-item" to="/prevencion/Procedimiento" onClick={() => setActivePopup(null)}>
                                    <span className="popup-icon material-symbols-rounded">slideshow</span>
                                    <span className="popup-label">Procedimientos</span>
                                </Link>
                            )}
                            {hasPermission("Reglamento Interno") && (
                                <Link className="popup-item" to="/ReglamentoInterno" onClick={() => setActivePopup(null)}>
                                    <span className="popup-icon material-symbols-rounded">rule</span>
                                    <span className="popup-label">Reglamento interno</span>
                                </Link>
                            )}
                            {hasPermission("Historial Trabajador") && (
                                <Link className="popup-item" to="/prevencion/Historialtrabajador" onClick={() => setActivePopup(null)}>
                                    <span className="popup-icon material-symbols-rounded">history</span>
                                    <span className="popup-label">Historial Trabajador</span>
                                </Link>
                            )}
                        </div>
                    </div>
                );

            case 'utilidades':
                return (
                    <div className={`module-popup ${getPopupTheme(selectedCard)}`} style={popupStyle}>
                        <div className="popup-header">
                            <span className="material-symbols-rounded">handyman</span>
                            <h3>Utilidades</h3>
                            <button className="popup-close" onClick={() => setActivePopup(null)}>
                                <span className="material-symbols-rounded">close</span>
                            </button>
                        </div>
                        <div className="popup-body">
                            <Link className="popup-item" to="/Cotizaciones" onClick={() => setActivePopup(null)}>
                                <span className="popup-icon material-symbols-rounded">person_add</span>
                                <span className="popup-label">Cotizacion personal</span>
                            </Link>
                            <Link className="popup-item" to="/CotizacionVenta" onClick={() => setActivePopup(null)}>
                                <span className="popup-icon material-symbols-rounded">request_quote</span>
                                <span className="popup-label">Cotizacion venta</span>
                            </Link>
                        </div>
                    </div>
                );

            case 'solicitudes':
                return (
                    <div className={`module-popup ${getPopupTheme(selectedCard)}`} style={popupStyle}>
                        <div className="popup-header">
                            <span className="material-symbols-rounded">mark_email_unread</span>
                            <h3>Solicitudes pendientes</h3>
                            <button className="popup-close" onClick={() => setActivePopup(null)}>
                                <span className="material-symbols-rounded">close</span>
                            </button>
                        </div>
                        <div className="popup-body">
                            <Link className="popup-item" to="/Administracion" onClick={() => setActivePopup(null)}>
                                <span className="popup-icon material-symbols-rounded">thumb_up</span>
                                <span className="popup-label">Aprobar solicitud</span>
                            </Link>
                        </div>
                    </div>
                );

            case 'administracion':
                return (
                    <div className={`module-popup ${getPopupTheme(selectedCard)}`} style={popupStyle}>
                        <div className="popup-header">
                            <span className="material-symbols-rounded">business</span>
                            <h3>Administración</h3>
                            <button className="popup-close" onClick={() => setActivePopup(null)}>
                                <span className="material-symbols-rounded">close</span>
                            </button>
                        </div>
                        <div className="popup-body">
                            {hasPermission("Carpeta Administrativa") && (
                                <Link className="popup-item" to="/CarpetaAdministrativa" onClick={() => setActivePopup(null)}>
                                    <span className="popup-icon material-symbols-rounded">folder_open</span>
                                    <span className="popup-label">Carpeta administrativa</span>
                                </Link>
                            )}
                        </div>
                    </div>
                );

            case 'perfil':
                return (
                    <div className={`module-popup popup-upward ${getPopupTheme(selectedCard)}`} style={popupStyle}>
                        <div className="popup-header">
                            <span className="material-symbols-rounded">account_circle</span>
                            <h3>{usuario || 'Perfil'}</h3>
                            <button className="popup-close" onClick={() => setActivePopup(null)}>
                                <span className="material-symbols-rounded">close</span>
                            </button>
                        </div>
                        <div className="popup-body">
                            <Link className="popup-item" to="/Prehome" onClick={() => setActivePopup(null)}>
                                <span className="popup-icon material-symbols-rounded">business</span>
                                <span className="popup-label">Empresas</span>
                            </Link>
                            {hasPermission("Permisos Sistema") && (
                                <a
                                    className="popup-item"
                                    onClick={() => {
                                        setShowPermisosModal(true);
                                        setActivePopup(null);
                                    }}
                                >
                                    <span className="popup-icon material-symbols-rounded">admin_panel_settings</span>
                                    <span className="popup-label">Permisos</span>
                                </a>
                            )}
                            <a className="popup-item" onClick={() => { logout(); setActivePopup(null); }}>
                                <span className="popup-icon material-symbols-rounded">logout</span>
                                <span className="popup-label">Cerrar Sesión</span>
                            </a>
                        </div>
                    </div>
                );

            default:
                return null;
        }
    };

    return (
        <>
            <aside
                className={`sidebar ${getEmpresaColor(selectedCard)} ${isSidebarToggled ? 'collapsed' : ''} ${isMenuActive ? 'menu-active' : ''}`}
                onMouseEnter={handleSidebarMouseEnter}
                onMouseLeave={handleSidebarMouseLeave}
            >
                {/* Sidebar header */}
                <header className="sidebar-header">
                    <Link to="/home" className="header-logo">
                        <img src={imageUrl} alt="Logo" />
                    </Link>
                    <button className="toggler menu-toggler" onClick={toggleMenu}>
                        <span className="material-symbols-rounded">menu</span>
                    </button>
                </header>

                <nav className="sidebar-nav">
                    {/* Primary navigation */}
                    <ul className="nav-list primary-nav">
                        {/* Recursos Humanos - Mostrar solo si tiene acceso al módulo o algún submódulo */}
                        {(hasPermission("Recursos Humanos") || hasAnySubmodulePermission(["Trabajadores", "Compensados", "Permisos", "Vacaciones", "Colaciones", "Liquidaciones", "Asistencia", "Finiquitos"])) && (
                            <li className={`nav-item ${expandedMenus.recursosHumanos ? 'expanded' : ''}`}>
                                <a className="nav-link" onClick={(e) => toggleSubmenu('recursosHumanos', e)}>
                                    <span className="nav-icon material-symbols-rounded">group</span>
                                    <span className="nav-label">Recursos Humanos</span>
                                    <span className="nav-chevron material-symbols-rounded">chevron_right</span>
                                </a>
                                <span className="nav-tooltip">Recursos Humanos</span>

                                {/* Submenu normal cuando sidebar está expandido */}
                                <div className={`submenu ${expandedMenus.recursosHumanos ? 'show' : ''}`}>
                                    {hasPermission("Trabajadores") && (
                                        <Link className="nav-link" to="/Trabajadores">
                                            <span className="nav-icon material-symbols-rounded">badge</span>
                                            <span className="nav-label">Trabajadores</span>
                                        </Link>
                                    )}
                                    {hasPermission("Trabajadores") && (
                                        <Link className="nav-link" to="/Contratos">
                                            <span className="nav-icon material-symbols-rounded">description</span>
                                            <span className="nav-label">Contratos</span>
                                        </Link>
                                    )}
                                    {hasPermission("Compensados") && (
                                        <Link className="nav-link" to="/Compensados">
                                            <span className="nav-icon material-symbols-rounded">description</span>
                                            <span className="nav-label">Compensados</span>
                                        </Link>
                                    )}
                                    {hasPermission("Permisos") && (
                                        <Link className="nav-link" to="/Permisos">
                                            <span className="nav-icon material-symbols-rounded">schedule</span>
                                            <span className="nav-label">Permisos</span>
                                        </Link>
                                    )}
                                    {hasPermission("Vacaciones") && (
                                        <Link className="nav-link" to="/Vacaciones">
                                            <span className="nav-icon material-symbols-rounded">beach_access</span>
                                            <span className="nav-label">Vacaciones</span>
                                        </Link>
                                    )}
                                    {hasPermission("Colaciones") && (
                                        <Link className="nav-link" to="/Colaciones">
                                            <span className="nav-icon material-symbols-rounded">restaurant</span>
                                            <span className="nav-label">Colaciones</span>
                                        </Link>
                                    )}
                                    {/* {hasPermission("Liquidaciones") && (
                                        <Link className="nav-link" to="/Liquidaciones">
                                            <span className="nav-icon material-symbols-rounded">receipt_long</span>
                                            <span className="nav-label">Liquidaciones</span>
                                        </Link>
                                    )} */}
                                    {hasPermission("Asistencia") && (
                                        <Link className="nav-link" to="/Asistencia">
                                            <span className="nav-icon material-symbols-rounded">event_available</span>
                                            <span className="nav-label">Asistencia</span>
                                        </Link>
                                    )}
                                    {hasPermission("Finiquitos") && (
                                        <Link className="nav-link" to="/Finiquitos">
                                            <span className="nav-icon material-symbols-rounded">contract</span>
                                            <span className="nav-label">Finiquitos</span>
                                        </Link>
                                    )}
                                </div>
                            </li>
                        )}

                        {/* Contabilidad - Mostrar solo si tiene acceso al módulo o algún submódulo */}
                        {(hasPermission("Contabilidad") || hasAnySubmodulePermission(["CreaLiquidaciones", "Centro Costos"])) && (
                            <li className={`nav-item ${expandedMenus.contabilidad ? 'expanded' : ''}`}>
                                <a className="nav-link" onClick={(e) => toggleSubmenu('contabilidad', e)}>
                                    <span className="nav-icon material-symbols-rounded">attach_money</span>
                                    <span className="nav-label">Contabilidad</span>
                                    <span className="nav-chevron material-symbols-rounded">chevron_right</span>
                                </a>
                                <span className="nav-tooltip">Contabilidad</span>

                                {/* Submenu normal cuando sidebar está expandido */}
                                <div className={`submenu ${expandedMenus.contabilidad ? 'show' : ''}`}>
                                    {hasPermission("CreaLiquidaciones") && (
                                        <Link className="nav-link" to="/CreacionLiquidaciones">
                                            <span className="nav-icon material-symbols-rounded">receipt_long</span>
                                            <span className="nav-label">Liquidaciones</span>
                                        </Link>
                                    )}
                                    {hasPermission("Centro Costos") && (
                                        <Link className="nav-link" to="/CentroCostos">
                                            <span className="nav-icon material-symbols-rounded">account_balance</span>
                                            <span className="nav-label">Centro Costos</span>
                                        </Link>
                                    )}
                                </div>
                            </li>
                        )}                        {/* Inventario - Mostrar solo si tiene acceso al módulo o algún submódulo */}
                        {(hasPermission("Inventario") || hasAnySubmodulePermission(["Gestion Inventario", "Asignacion Inventario"])) && (
                            <li className={`nav-item ${expandedMenus.inventario ? 'expanded' : ''}`}>
                                <a className="nav-link" onClick={(e) => toggleSubmenu('inventario', e)}>
                                    <span className="nav-icon material-symbols-rounded">inventory_2</span>
                                    <span className="nav-label">Inventario</span>
                                    <span className="nav-chevron material-symbols-rounded">chevron_right</span>
                                </a>
                                <span className="nav-tooltip">Inventario</span>

                                {/* Submenu normal cuando sidebar está expandido */}
                                <div className={`submenu ${expandedMenus.inventario ? 'show' : ''}`}>
                                    {hasPermission("Gestion Inventario") && (
                                        <Link className="nav-link" to="/Inventario">
                                            <span className="nav-icon material-symbols-rounded">warehouse</span>
                                            <span className="nav-label">Lista de Productos</span>
                                        </Link>
                                    )}
                                    {hasPermission("Asignacion Inventario") && (
                                        <Link className="nav-link" to="/AsignacionInventario">
                                            <span className="nav-icon material-symbols-rounded">assignment_ind</span>
                                            <span className="nav-label">Asignaciones</span>
                                        </Link>
                                    )}
                                </div>
                            </li>
                        )}

                        {/* Prevencion - Mostrar solo si tiene acceso al módulo o algún submódulo */}
                        {(hasPermission("Prevencion") || hasAnySubmodulePermission(["Procedimientos", "Formatos", "Historial Trabajador", "Multimedia", "Faenas", "Registro Prevencion", "Documentos"])) && (
                            <li className={`nav-item ${expandedMenus.prevencion ? 'expanded' : ''}`}>
                                <a className="nav-link" onClick={(e) => toggleSubmenu('prevencion', e)}>
                                    <span className="nav-icon material-symbols-rounded">construction</span>
                                    <span className="nav-label">Prevención</span>
                                    <span className="nav-chevron material-symbols-rounded">chevron_right</span>
                                </a>
                                <span className="nav-tooltip">Prevención</span>

                                {/* Submenu normal cuando sidebar está expandido */}
                                <div className={`submenu ${expandedMenus.prevencion ? 'show' : ''}`}>
                                    {hasPermission("Faenas") && (
                                        <Link className="nav-link" to="/prevencion/Faenas">
                                            <span className="nav-icon material-symbols-rounded">format_list_numbered</span>
                                            <span className="nav-label">Faenas</span>
                                        </Link>
                                    )}
                                    {hasPermission("Registro Prevencion") && (
                                        <Link className="nav-link" to="/prevencion/RegistroPrevencion">
                                            <span className="nav-icon material-symbols-rounded">print</span>
                                            <span className="nav-label">Registro prevención</span>
                                        </Link>
                                    )}
                                    {hasPermission("Documentos") && (
                                        <Link className="nav-link" to="/prevencion/Documentos">
                                            <span className="nav-icon material-symbols-rounded">description</span>
                                            <span className="nav-label">Documentos</span>
                                        </Link>
                                    )}
                                    {hasPermission("Formatos") && (
                                        <Link className="nav-link" to="/prevencion/Formatos">
                                            <span className="nav-icon material-symbols-rounded">article</span>
                                            <span className="nav-label">Formatos</span>
                                        </Link>
                                    )}
                                    {hasPermission("Procedimientos") && (
                                        <Link className="nav-link" to="/prevencion/Procedimiento">
                                            <span className="nav-icon material-symbols-rounded">slideshow</span>
                                            <span className="nav-label">Procedimientos</span>
                                        </Link>
                                    )}
                                    {hasPermission("Reglamento Interno") && (
                                        <Link className="nav-link" to="/prevencion/ReglamentoInterno">
                                            <span className="nav-icon material-symbols-rounded">rule</span>
                                            <span className="nav-label">Reglamento interno</span>
                                        </Link>
                                    )}
                                    {hasPermission("Historial Trabajador") && (
                                        <Link className="nav-link" to="/prevencion/Historialtrabajador">
                                            <span className="nav-icon material-symbols-rounded">history</span>
                                            <span className="nav-label">Historial Trabajador</span>
                                        </Link>
                                    )}
                                </div>

                                {/* Popup cuando sidebar está colapsado */}
                                {isSidebarToggled && activePopup === 'prevencion' && (
                                    <div
                                        className="module-popup"
                                        style={{
                                            '--popup-left': `${popupPosition.left}px`,
                                            '--popup-top': `${popupPosition.top}px`
                                        }}
                                    >
                                        <div className="popup-header">
                                            <span className="material-symbols-rounded">construction</span>
                                            <h3>Prevención</h3>
                                            <button className="popup-close" onClick={() => setActivePopup(null)}>
                                                <span className="material-symbols-rounded">close</span>
                                            </button>
                                        </div>
                                        <div className="popup-body">
                                            {hasPermission("Faenas") && (
                                                <Link className="popup-item" to="/prevencion/Faenas" onClick={() => setActivePopup(null)}>
                                                    <span className="popup-icon material-symbols-rounded">format_list_numbered</span>
                                                    <span className="popup-label">Faenas</span>
                                                </Link>
                                            )}
                                            {hasPermission("Registro Prevencion") && (
                                                <Link className="popup-item" to="/prevencion/RegistroPrevencion" onClick={() => setActivePopup(null)}>
                                                    <span className="popup-icon material-symbols-rounded">print</span>
                                                    <span className="popup-label">Registro prevención</span>
                                                </Link>
                                            )}
                                            {hasPermission("Documentos") && (
                                                <Link className="popup-item" to="/prevencion/Documentos" onClick={() => setActivePopup(null)}>
                                                    <span className="popup-icon material-symbols-rounded">description</span>
                                                    <span className="popup-label">Documentos</span>
                                                </Link>
                                            )}
                                            {hasPermission("Formatos") && (
                                                <Link className="popup-item" to="/prevencion/Formatos" onClick={() => setActivePopup(null)}>
                                                    <span className="popup-icon material-symbols-rounded">article</span>
                                                    <span className="popup-label">Formatos</span>
                                                </Link>
                                            )}
                                            {hasPermission("Procedimientos") && (
                                                <Link className="popup-item" to="/prevencion/Procedimiento" onClick={() => setActivePopup(null)}>
                                                    <span className="popup-icon material-symbols-rounded">slideshow</span>
                                                    <span className="popup-label">Procedimientos</span>
                                                </Link>
                                            )}
                                            {hasPermission("Procedimientos") && (
                                                <Link className="popup-item" to="/Procedimientos" onClick={() => setActivePopup(null)}>
                                                    <span className="popup-icon material-symbols-rounded">rule</span>
                                                    <span className="popup-label">Reglamento interno</span>
                                                </Link>
                                            )}
                                            {hasPermission("Historial Trabajador") && (
                                                <Link className="popup-item" to="/prevencion/Historialtrabajador" onClick={() => setActivePopup(null)}>
                                                    <span className="popup-icon material-symbols-rounded">history</span>
                                                    <span className="popup-label">Historial Trabajador</span>
                                                </Link>
                                            )}
                                        </div>
                                    </div>
                                )}
                            </li>
                        )}

                        {/* Utilidades */}
                        {hasPermission("Utilidades") && (
                            <li className={`nav-item ${expandedMenus.utilidades ? 'expanded' : ''}`}>
                                <a className="nav-link" onClick={(e) => toggleSubmenu('utilidades', e)}>
                                    <span className="nav-icon material-symbols-rounded">handyman</span>
                                    <span className="nav-label">Adquisiciones</span>
                                    <span className="nav-chevron material-symbols-rounded">chevron_right</span>
                                </a>
                                <span className="nav-tooltip">Utilidades</span>

                                {/* Submenu normal cuando sidebar está expandido */}
                                <div className={`submenu ${expandedMenus.utilidades ? 'show' : ''}`}>
                                    <Link className="nav-link" to="/Cotizaciones">
                                        <span className="nav-icon material-symbols-rounded">person_add</span>
                                        <span className="nav-label">Cotizacion personal</span>
                                    </Link>
                                    <Link className="nav-link" to="/CotizacionVenta">
                                        <span className="nav-icon material-symbols-rounded">request_quote</span>
                                        <span className="nav-label">Cotizacion venta</span>
                                    </Link>
                                    {hasPermission("Ordenes Compra") && (
                                        <Link className="nav-link" to="/OrdenCompras">
                                            <span className="nav-icon material-symbols-rounded">shopping_cart</span>
                                            <span className="nav-label">Ordenes Compra</span>
                                        </Link>
                                    )}
                                </div>

                                {/* Popup cuando sidebar está colapsado */}
                                {isSidebarToggled && activePopup === 'utilidades' && (
                                    <div
                                        className="module-popup"
                                        style={{
                                            '--popup-left': `${popupPosition.left}px`,
                                            '--popup-top': `${popupPosition.top}px`
                                        }}
                                    >
                                        <div className="popup-header">
                                            <span className="material-symbols-rounded">handyman</span>
                                            <h3>Adquisiciones</h3>
                                            <button className="popup-close" onClick={() => setActivePopup(null)}>
                                                <span className="material-symbols-rounded">close</span>
                                            </button>
                                        </div>
                                        <div className="popup-body">
                                            <Link className="popup-item" to="/Cotizaciones" onClick={() => setActivePopup(null)}>
                                                <span className="popup-icon material-symbols-rounded">person_add</span>
                                                <span className="popup-label">Cotizacion personal</span>
                                            </Link>
                                            <Link className="popup-item" to="/CotizacionVenta" onClick={() => setActivePopup(null)}>
                                                <span className="popup-icon material-symbols-rounded">request_quote</span>
                                                <span className="popup-label">Cotizacion venta</span>
                                            </Link>
                                            {hasPermission("Ordenes Compra") && (
                                                <Link className="popup-item" to="/OrdenCompras" onClick={() => setActivePopup(null)}>
                                                    <span className="popup-icon material-symbols-rounded">shopping_cart</span>
                                                    <span className="popup-label">Ordenes Compra</span>
                                                </Link>
                                            )}
                                        </div>
                                    </div>
                                )}
                            </li>
                        )}

                        {/* Aprobación solicitudes */}
                        {hasPermission("Solicitudes") && (
                            <li className={`nav-item ${expandedMenus.solicitudes ? 'expanded' : ''}`}>
                                <a className="nav-link" onClick={(e) => toggleSubmenu('solicitudes', e)}>
                                    <span className="nav-icon material-symbols-rounded">mark_email_unread</span>
                                    <span className="nav-label">Solicitudes</span>
                                    <span className="nav-chevron material-symbols-rounded">chevron_right</span>
                                </a>
                                <span className="nav-tooltip">Solicitudes</span>

                                {/* Submenu normal cuando sidebar está expandido */}
                                <div className={`submenu ${expandedMenus.solicitudes ? 'show' : ''}`}>
                                    <Link className="nav-link" to="/Administracion">
                                        <span className="nav-icon material-symbols-rounded">thumb_up</span>
                                        <span className="nav-label">Aprobar solicitud</span>
                                    </Link>
                                </div>

                                {/* Popup cuando sidebar está colapsado */}
                                {isSidebarToggled && activePopup === 'solicitudes' && (
                                    <div
                                        className="module-popup"
                                        style={{
                                            '--popup-left': `${popupPosition.left}px`,
                                            '--popup-top': `${popupPosition.top}px`
                                        }}
                                    >
                                        <div className="popup-header">
                                            <span className="material-symbols-rounded">mark_email_unread</span>
                                            <h3>Solicitudes pendientes</h3>
                                            <button className="popup-close" onClick={() => setActivePopup(null)}>
                                                <span className="material-symbols-rounded">close</span>
                                            </button>
                                        </div>
                                        <div className="popup-body">
                                            <Link className="popup-item" to="/Administracion" onClick={() => setActivePopup(null)}>
                                                <span className="popup-icon material-symbols-rounded">thumb_up</span>
                                                <span className="popup-label">Aprobar solicitud</span>
                                            </Link>
                                        </div>
                                    </div>
                                )}
                            </li>
                        )}

                        {/* Administración - Mostrar solo si tiene acceso al módulo o algún submódulo */}
                        {(hasPermission("Administracion") || hasAnySubmodulePermission(["Permisos Sistema", "Carpeta Administrativa", "Aprobar Solicitud"])) && (
                            <li className={`nav-item ${expandedMenus.administracion ? 'expanded' : ''}`}>
                                <a className="nav-link" onClick={(e) => toggleSubmenu('administracion', e)}>
                                    <span className="nav-icon material-symbols-rounded">business</span>
                                    <span className="nav-label">Administración</span>
                                    <span className="nav-chevron material-symbols-rounded">chevron_right</span>
                                </a>
                                <span className="nav-tooltip">Administración</span>

                                {/* Submenu normal cuando sidebar está expandido */}
                                <div className={`submenu ${expandedMenus.administracion ? 'show' : ''}`}>
                                    {hasPermission("Carpeta Administrativa") && (
                                        <Link className="nav-link" to="/CarpetaAdministrativa">
                                            <span className="nav-icon material-symbols-rounded">folder_open</span>
                                            <span className="nav-label">Documentos</span>
                                        </Link>
                                    )}
                                    {hasPermission("Aprobar Solicitud") && (
                                        <Link className="nav-link" to="/Administracion">
                                            <span className="nav-icon material-symbols-rounded">approval</span>
                                            <span className="nav-label">Aprobar solicitud</span>
                                        </Link>
                                    )}
                                </div>

                                {/* Popup cuando sidebar está colapsado */}
                                {isSidebarToggled && activePopup === 'administracion' && (
                                    <div
                                        className="module-popup"
                                        style={{
                                            '--popup-left': `${popupPosition.left}px`,
                                            '--popup-top': `${popupPosition.top}px`
                                        }}
                                    >
                                        <div className="popup-header">
                                            <span className="material-symbols-rounded">business</span>
                                            <h3>Administración</h3>
                                            <button className="popup-close" onClick={() => setActivePopup(null)}>
                                                <span className="material-symbols-rounded">close</span>
                                            </button>
                                        </div>
                                        <div className="popup-body">
                                            {hasPermission("Carpeta Administrativa") && (
                                                <Link className="popup-item" to="/CarpetaAdministrativa" onClick={() => setActivePopup(null)}>
                                                    <span className="popup-icon material-symbols-rounded">folder_open</span>
                                                    <span className="popup-label">Carpeta administrativa</span>
                                                </Link>
                                            )}
                                            {hasPermission("Aprobar Solicitud") && (
                                                <Link className="popup-item" to="/Administracion" onClick={() => setActivePopup(null)}>
                                                    <span className="popup-icon material-symbols-rounded">approval</span>
                                                    <span className="popup-label">Aprobar solicitud</span>
                                                </Link>
                                            )}
                                        </div>
                                    </div>
                                )}
                            </li>
                        )}
                    </ul>

                    {/* Secondary bottom navigation */}
                    <ul className="nav-list secondary-nav">
                        {/* Notificaciones - Solo si tiene permiso de Administracion */}
                        {hasPermission("Administracion") && (
                            <li className="nav-item">
                                <a className="nav-link" onClick={toggleNotifications}>
                                    <span className="nav-icon material-symbols-rounded">notifications</span>
                                    <span className="nav-label">
                                        Notificaciones
                                        {(listadoVacaciones.length + listadoSolicitudesOrdenesCompra.length) > 0 && (
                                            <span className="notification-badge">
                                                {listadoVacaciones.length + listadoSolicitudesOrdenesCompra.length}
                                            </span>
                                        )}
                                    </span>
                                </a>
                                <span className="nav-tooltip">Notificaciones</span>

                                {/* Panel de notificaciones - Solo cuando sidebar está expandido */}
                                {!isSidebarToggled && showNotifications && (
                                    <div className="notifications-panel">
                                        <div className="notifications-header">
                                            <h6>Alertas</h6>
                                            <button onClick={() => setShowNotifications(false)} className="close-btn">
                                                <span className="material-symbols-rounded">close</span>
                                            </button>
                                        </div>
                                        <div className="notifications-body">
                                            {/* Solicitudes de Órdenes de Compra */}
                                            {listadoSolicitudesOrdenesCompra.length > 0 && (
                                                <div className="notification-section">

                                                    <h6 className="notification-section-title" style={{ marginLeft: '15px', marginBottom: '10px', fontWeight: 'bold', color: '#495057' }}>Órdenes de Compra</h6>
                                                    {listadoSolicitudesOrdenesCompra.map((solicitud, index) => (
                                                        <div key={`orden-${index}`} className="notification-item">
                                                            <div className="notification-icon">
                                                                <span className="material-symbols-rounded">shopping_cart</span>
                                                            </div>
                                                            <div className="notification-content">
                                                                <div className="notification-date">
                                                                    {new Date(solicitud.Fecha_Solicitud).toLocaleDateString()}
                                                                </div>
                                                                <div className="notification-text">
                                                                    {`${solicitud.Usuario_Crea} solicita aprobación de Orden N° ${solicitud.Observacion.match(/N° (\d+)/)?.[1] || 'N/A'}`}
                                                                </div>
                                                                <div className="notification-detail">
                                                                    {`Proveedor: ${solicitud.Observacion.match(/Proveedor: ([^-]+)/)?.[1]?.trim() || 'N/A'} - ${solicitud.Observacion.match(/Total: (\$[\d,.]+)/)?.[1] || 'N/A'}`}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            )}

                                            {/* Solicitudes de Vacaciones */}
                                            {listadoVacaciones.length > 0 && (
                                                <div className="notification-section">
                                                    <h6 className="notification-section-title" style={{ marginLeft: '15px', marginBottom: '10px', fontWeight: 'bold', color: '#495057' }}>Vacaciones</h6>
                                                    {listadoVacaciones.map((alerta, index) => (
                                                        <div key={`vacacion-${index}`} className="notification-item">
                                                            <div className="notification-icon">
                                                                <span className="material-symbols-rounded">warning</span>
                                                            </div>
                                                            <div className="notification-content">
                                                                <div className="notification-date">
                                                                    {new Date(alerta.Fecha_Solicitud).toLocaleDateString()}
                                                                </div>
                                                                <div className="notification-text">
                                                                    {`Atención ${alerta.Nombre_Completo} ha solicitado ${alerta.Dias_Solicitados} días de vacaciones.`}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            )}

                                            {/* Mensaje cuando no hay notificaciones */}
                                            {listadoVacaciones.length === 0 && listadoSolicitudesOrdenesCompra.length === 0 && (
                                                <div className="no-notifications">
                                                    No hay solicitudes pendientes.
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                )}
                            </li>
                        )}

                        {/* Perfil del Usuario */}
                        <li className="nav-item profile-nav-item">
                            <a className="nav-link" onClick={(e) => isSidebarToggled ? toggleSubmenu('perfil', e) : toggleProfileMenu()}>
                                <span className="nav-icon material-symbols-rounded">account_circle</span>
                                <span className="nav-label">{usuario || 'Perfil'}</span>
                            </a>
                            <span className="nav-tooltip">Perfil</span>

                            {/* Menu del perfil - Solo cuando sidebar está expandido */}
                            {!isSidebarToggled && showProfileMenu && (
                                <div className="profile-menu">
                                    <div className="profile-header">
                                        <img
                                            src="/img/perfilM.svg"
                                            alt="Profile"
                                            className="profile-image"
                                        />
                                        <span className="profile-name">{usuario}</span>
                                        <button onClick={() => setShowProfileMenu(false)} className="close-btn">
                                            <span className="material-symbols-rounded">close</span>
                                        </button>
                                    </div>
                                    <div className="profile-menu-items">
                                        <Link
                                            to="/Prehome"
                                            className="profile-menu-item"
                                            onClick={() => setShowProfileMenu(false)}
                                        >
                                            <span className="material-symbols-rounded">business</span>
                                            <span>Empresas</span>
                                        </Link>
                                        {hasPermission("Permisos Sistema") && (
                                            <a
                                                className="profile-menu-item"
                                                onClick={() => {
                                                    setShowPermisosModal(true);
                                                    setShowProfileMenu(false);
                                                }}
                                            >
                                                <span className="material-symbols-rounded">admin_panel_settings</span>
                                                <span>Permisos</span>
                                            </a>
                                        )}
                                        <a className="profile-menu-item" onClick={logout}>
                                            <span className="material-symbols-rounded">logout</span>
                                            <span>Cerrar Sesión</span>
                                        </a>
                                    </div>
                                </div>
                            )}
                        </li>
                    </ul>
                </nav>

                {/* Modal de gestión de permisos */}
                <PermisosModal
                    show={showPermisosModal}
                    onHide={() => setShowPermisosModal(false)}
                    cookies={cookies || cookiesState}
                />
            </aside>

            {/* Popups renderizados fuera del sidebar */}
            {renderPopups()}
        </>
    );
}

export default Sidebar;
